import type { CheckoutPlatform, PaymentOptions } from '../../api/marketplace';
import { hapticImpact } from '../../lib/telegram';
import './PaymentSheet.css';

interface PaymentSheetProps {
  open: boolean;
  payments: PaymentOptions;
  busy: boolean;
  starsAmount?: number;
  rubAmount?: number;
  onClose: () => void;
  onPay: (platform: CheckoutPlatform) => void;
}

export function PaymentSheet({ open, payments, busy, starsAmount, rubAmount, onClose, onPay }: PaymentSheetProps) {
  if (!open) return null;

  const tributeReady = payments.tribute;
  const starsReady = payments.stars;

  return (
    <div className="pay-sheet">
      <button type="button" className="pay-sheet__scrim" aria-label="Закрыть" onClick={onClose} />
      <div className="pay-sheet__panel" role="dialog" aria-label="Способ оплаты">
        <p className="pay-sheet__eyebrow">Оплата</p>
        <h2 className="pay-sheet__title">Приобрести</h2>
        <p className="pay-sheet__hint">Выбери, чем списать</p>

        {starsReady ? (
          <button
            type="button"
            className="pay-sheet__option"
            disabled={busy}
            onClick={() => {
              hapticImpact('rigid');
              onPay('telegram');
            }}
          >
            <span className="pay-sheet__option-title">Telegram Stars</span>
            <span className="pay-sheet__option-hint">
              {starsAmount ? `${starsAmount} Stars` : 'Оплата звёздами внутри Telegram'}
            </span>
          </button>
        ) : null}

        {tributeReady ? (
          <button
            type="button"
            className="pay-sheet__option"
            disabled={busy}
            onClick={() => {
              hapticImpact('rigid');
              onPay('tribute');
            }}
          >
            <span className="pay-sheet__option-title">СБП, Банковская карта (без комиссии)</span>
            <span className="pay-sheet__option-hint">
              {rubAmount ? `${rubAmount} ₽` : 'Оплата картой или через СБП'}
            </span>
          </button>
        ) : null}

        {!starsReady && !tributeReady ? <p className="pay-sheet__hint">Сейчас нет доступных способов оплаты</p> : null}

        <button type="button" className="pay-sheet__cancel" disabled={busy} onClick={onClose}>
          {busy ? 'Открываю оплату…' : 'Отмена'}
        </button>
      </div>
    </div>
  );
}
